var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "220px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "500px",
                      "padding-left": "16px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.gridOptions.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers", staticStyle: { flex: "none" } },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "back", type: "primary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "Edit", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "print",
                                  disabled: _vm.isEditing,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onPrintHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew || _vm.action === "edit",
                                expression: "isNew || action==='edit'"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "save", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.save(false)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "saveDone", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.saveDoneHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_SaveDone"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "cancel", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(_vm.onRefresh)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "warehousingDetail",
                          attrs: {
                            label: _vm.$t("Message.Main"),
                            lazy: true,
                            name: "baseInfo"
                          }
                        },
                        [
                          _c("warehousing-detail", {
                            ref: "baseInfo",
                            attrs: {
                              "warehouse-in-uuid": _vm.currentRow.uuid,
                              lob: _vm.lob,
                              action: _vm.action
                            },
                            on: {
                              refreshHandler: function($event) {
                                _vm.isRefreshBase = false
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.Charge"),
                            lazy: true,
                            name: "tabCharges"
                          }
                        },
                        [
                          _c("tab-warehousing-charge", {
                            ref: "tabCharges",
                            attrs: {
                              "warehouse-in-uuid": _vm.currentRow.uuid,
                              action: _vm.action
                            },
                            on: {
                              refreshHandler: function($event) {
                                _vm.isRefreshCharge = false
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }